import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import './chunk-590a6902.js';
import './chunk-ea9bc877.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-113685dc.js';
import './chunk-91404fa9.js';
import './chunk-a8516afd.js';
import './chunk-42f463e6.js';
import './chunk-b66a83ce.js';
import './chunk-97f201e0.js';
import './chunk-40f06d9c.js';
import { T as Timepicker } from './chunk-03f0ac1a.js';
export { T as BTimepicker } from './chunk-03f0ac1a.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Timepicker);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/timepicker.js
// module id = sBwo
// module chunks = 0 1